module.exports = __webpack_public_path__ + "static/media/shield.d6b465eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/TradeCryptoResources/shield.svg
// module id = 168
// module chunks = 0